import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from '@mui/material';
import { STModal } from '../../../commons/Modal';
import { getNumDevices } from '../../../../redux/commander/selectors';
import { deleteAssociatedDevice } from '../../../../redux/commander/actions/deleteAssociatedDevice';
import { withPolyglot } from '../../../../i18n';
import { withShowMessage } from '../../../HOC/withShowMessage';
import { withShowErrorMessage } from '../../../HOC';
import { withRouter } from '../../../../util/route-dom';
import LoadingButton from '@mui/lab/LoadingButton';

/**
 * Device remove
 * This class allow to remove a device
 */
export function DeviceRemove(props) {
  const {
    closeRemoveDevice,
    polyglot,
    showMessage,
    showErrorMessage,
    deviceId = '',
    navigate,
    showRemoveDevice,
    deleteAssociatedDevice,
  } = props;

  const [loading, setLoading] = React.useState(false);

  const removeAssociatedDevice = useCallback(async () => {
    setLoading(true);
    try {
      await deleteAssociatedDevice(deviceId);
      closeRemoveDevice();
      showMessage(polyglot.t('device.remove_successful_message'));
      navigate('/devicemanager', { replace: true });
    } catch (error) {
      showErrorMessage(error);
    } finally {
      setLoading(false);
    }
  }, [
    closeRemoveDevice,
    polyglot,
    showMessage,
    showErrorMessage,
    deviceId,
    navigate,
    deleteAssociatedDevice,
  ]);

  return (
    <div>
      <STModal
        open={showRemoveDevice}
        title={polyglot.t('device.remove_dialog_title')}
        onClose={closeRemoveDevice}
        disabledClose={loading}
        buttonActions={
          <>
            <Button
              onClick={closeRemoveDevice}
              variant="text"
              disabled={loading}
            >
              {polyglot.t('device.cancel_button_title')}
            </Button>
            <LoadingButton
              variant="contained"
              color="error"
              onClick={removeAssociatedDevice}
              loading={loading}
            >
              {polyglot.t('device.remove_button_title')}
            </LoadingButton>
          </>
        }
      >
        <p>{polyglot.t('device.remove_dialog_text')}</p>
      </STModal>
    </div>
  );
}

DeviceRemove.propTypes = {
  showErrorMessage: PropTypes.func.isRequired,
  showMessage: PropTypes.func.isRequired,
  polyglot: PropTypes.shape({
    t: PropTypes.func,
    locale: PropTypes.func,
  }).isRequired,
  deviceId: PropTypes.string,
  showRemoveDevice: PropTypes.bool.isRequired,
  closeRemoveDevice: PropTypes.func.isRequired,
  deleteAssociatedDevice: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  totalDevices: getNumDevices(state),
});

export default connect(mapStateToProps, { deleteAssociatedDevice })(
  withRouter(withShowMessage(withShowErrorMessage(withPolyglot(DeviceRemove))))
);
